import React from "react";
import AdminProductEdit from "../../../components/admin/products/admin-product-edit";

import AdminTemplate from "../../../templates/admin-template";

const AdminProductEditPage = () => {
  return (
    <AdminTemplate>
      <AdminProductEdit />
    </AdminTemplate>
  );
};

export default AdminProductEditPage;
